/// <reference path="../references.ts" />

'use strict';
import Seo from './seo-manager.srv';
import alternateLangsRoutingBinder from './alternate-langs-routing-binder.run';

angular.module('seo', ['core', 'prerender', 'ui.router'])
	.service('seoManager', Seo)
	.run(alternateLangsRoutingBinder);
